import { Routes } from '@angular/router';
import { TwoColumnsRightComponent } from '../upgrade/main.template.directive';
import { setupGuard } from '@fry/upgrade/setup.guard';
import { authGuard, forceOnlineGuard } from '@fry-it/risr-core';
import { FilesListComponent } from '../upgrade/files.directive';

export const filesRoutes: Routes = [
  {
    path: 'files',
    component: TwoColumnsRightComponent,
    canActivate: [setupGuard, authGuard],
    children: [
      {
        path: '',
        component: FilesListComponent,
        data: {
          state: 'epf.files.index'
        },
        canActivate: [forceOnlineGuard]
      }
    ]
  }
];
